<template>
  <div class="subheader py-6 pt-lg-6 subheader-transparent transparent" id="kt_subheader">
    <div class="d-flex align-items-end justify-content-between flex-wrap flex-sm-nowrap container">
      <div class="d-flex align-items-center flex-wrap mr-2">
        <!--begin::Heading-->
        <div class="d-flex flex-column">
          <!--begin::Title-->
          <ul class="d-flex align-items-center font-weight-bold my-2 p-0">
            <router-link :to="'/'" class="opacity-50 hover-opacity-75">
              <i class="flaticon2-shelter text-dark icon-1x"></i>
            </router-link>

            <div v-for="(breadcrumb, i) in breadcrumbs" :key="i">
              <span class="label label-dot label-sm bg-dark opacity-50 mx-3"></span>
              <router-link
                :key="`${i}-${breadcrumb.id}`"
                v-if="breadcrumb.route"
                :to="{ name: breadcrumb.route }"
                class="text-dark opacity-50 hover-opacity-75"
              >
                {{ breadcrumb.title }}
              </router-link>
              <span
                class="text-dark opacity-50 hover-opacity-75"
                :key="`${i}-${breadcrumb.id}`"
                v-if="!breadcrumb.route"
              >
                {{ breadcrumb.title }}
              </span>
            </div>
          </ul>
          <div class="title-container my-0 mt-5">
            <inline-svg v-if="bc_icon" class="svg mr-4 ml-0 mt-auto mb-auto" :src="bc_icon" />
            <h2 class="text-black font-weight-bold my-2 mr-5">
              {{ bc_title }}
            </h2>
          </div>
        </div>
      </div>

      <!-- Header actions buttons -->
      <HeaderActions />
    </div>
  </div>
</template>

<script>
import useTranslate from "@/core/composables/translate";
import HeaderActions from "@/view/layout/subheader/HeaderActions.vue";

export default {
  name: "Subheader",
  components: { HeaderActions },

  props: {
    breadcrumbs: Array,
    bc_title: String,
    bc_icon: String,
  },
  setup() {
    const { translate } = useTranslate();
    return {
      translate,
    };
  },
  inject: ["isViewportMobile"],
};
</script>

<style lang="scss">
.title-container {
  display: flex;
  height: 35px;
  & > svg {
    max-height: inherit;
    margin: auto 8px auto 0;
  }
}

.cirx-subheader-btn {
  align-self: flex-end;
}

.cirx-subheader-btn > button {
  border-color: var(--custom-primary-color) !important;
  background-color: var(--custom-primary-color) !important;
}

.custom-v-dropdown {
  &.dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  &.dropdown-menu {
    margin: 0;
    .b-dropdown-text {
      padding: 0;
    }
  }
}
</style>
